import PropTypes from 'prop-types';
import React from 'react';

import {REPLACEMENT_DOG_STRING} from 'modules/GreyhoundRacing/consts';

import Cloth from 'modules/Common/components/Cloth';
import Ordinal from 'modules/Common/components/Ordinal';

require('./GreyhoundRacingRacecardResultRunner.scss');

export default function GreyhoundRacingRacecardResultRunner(props) {
  const {
    runner : {
      position,
      finishDistance,
      clothNo,
      greyhoundName,
      odds,
      runSplit = 'N/A',
      runTime,
      trainer : {
        name: trainerName
      },
      runDesc,
      reserve
    }
  } = props;

  return (
    <section className='gh-racing-result-runner-wrapper'>
      <div className='gh-racing-result-runner-key-info-container'>
        <div className='gh-racing-result-runner-position'>
          <Ordinal n={position}/>
        </div>
        <div className='gh-racing-result-runner-distance'>
          {finishDistance}
        </div>
        <div className='gh-racing-result-runner-cloth'>
          <Cloth number={clothNo} />
        </div>
        <div className='gh-racing-result-runner-greyhound-info'>
          <div className='row'>
            <span className='gh-racing-result-runner-greyhound-name'>
              <span to={`/greyhounds/profiles/dog/${greyhoundName}`}>{greyhoundName}</span>
            </span>
            <span
              className='gh-racing-result-runner-betting-odds sui-odds'>
              {odds}
            </span>
          </div>
          <div className='row'>
            <div className='gh-racing-result-runner-greyhound-sub-info'>
              <span className="gh-racing-result-runner-split"><span className="gh-racing-result-runner-split-emphasis">Split:</span> {runSplit}</span>
              <span className="gh-racing-result-runner-time"><span className="gh-racing-result-runner-time-emphasis">Time:</span> {runTime}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="gh-racing-result-runner-run-info-container">
        {
          reserve ? (
            <span className="gh-racing-result-runner-reserve">{REPLACEMENT_DOG_STRING}</span>
          ) : (
            <span className="gh-racing-result-runner-run-trainer"><span className="gh-racing-result-runner-run-trainer-emphasis">T:</span> {trainerName}</span>
          )
        }
        <span className="gh-racing-result-runner-run-desc">{runDesc}</span>
      </div>

    </section>
  );
}

GreyhoundRacingRacecardResultRunner.propTypes = {
  runner: PropTypes.object,
  showLastRun: PropTypes.bool
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/components/GreyhoundRacingRacecardResultRunner.js